(function (ws) {
    'use strict';

    ws.views.defaultSalesorgOffice = ws.views.modal.extend({
        events: {
            'click .defaultSubmit': 'defaultSalesOrgOfficeSubmit',
            'click .defaultCancel': 'cancelModal',
            'change .sales-deforg': 'getSalesOffices',
            'change .sales-off': 'removeErrorMsg'
        },

        /**
         * Initialize
         */
        initialize: function() {
            this.$salesDefOrg = $('.sales-deforg');
            this.$salesOff = $('.sales-off');
            $('.sales-deforg, .sales-off').select2({width: '100%'});
            this.$salesDefOrg.val($('.defaultSalesOrg').val()).trigger('change');
            this.initSalesOfficeDropDown();
            ws.views.modal.prototype.initialize.call(this);
        },

        //on open
        onOpen: function () {
            this.$salesDefOrg.val($('.defaultSalesOrg').val()).trigger('change');
            this.$salesOff.val($('.defaultSalesOffice').val()).trigger('change');
            ws.views.modal.prototype.onOpen.call(this);
        },

        removeErrorMsg: function() {
            this.$('.salesOffMandatoryCls').addClass('hide');
        },

        defaultSalesOrgOfficeSubmit: function(e) {
            if (this.$salesDefOrg.val() !== '' && this.$salesOff.val() === '') {
                this.$('.salesOffMandatoryCls').removeClass('hide');
            } else {
                $.ajax({
                    url: globals.path.api.quoting.updateDefaultSalesOrgDetails + '?' + CSRF,
                    type: 'PUT',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        salesOrg: this.$salesDefOrg.val(),
                        salesOffice: this.$salesOff.val()
                    }),
                    processData: false,

                    success: function (res) {
                        if (res) {
                            location.reload();
                        }
                    },

                    error: function (er) {
                        console.log(er);
                    }
                });
            }
        },

        cancelModal: function(e) {
            ws.views.modal.prototype.closeModal.call(this);
        },

        getSalesOffices(e) {
            var salesOrg = this.$('.sales-deforg').val();

            if (!salesOrg) {
                this.$salesOff.val(null).trigger('change');
                this.$salesOff.attr('disabled', 'disabled');
            } else {
                this.$salesOff.select2({
                    ajax: {
                        url: globals.path.api.quoting.searchsalesofficeUrl,
                        dataType: 'json',
                        delay: 250,
                        data:  {
                            salesOrg: salesOrg
                        },

                        processResults: data => ({
                            results: data.map(item => ({
                                id: item.code,
                                text: item.description
                            }))
                        }),

                        cache: true,
                        minimumInputLength: 2
                    }
                });

                this.$salesOff.attr('disabled', false);
                this.$salesOff.val(null).trigger('change');
            }
        },

        initSalesOfficeDropDown: function() {
            var options = `<option value="">Select</option>`;
            $.ajax({
                url: globals.path.api.quoting.searchsalesofficeUrl,
                type: 'GET',
                contentType: 'application/json',
                data: {salesOrg: $('.defaultSalesOrg').val()},
                success: function (res) {
                    if (res) {
                        _.each(res, option => {
                            options += `<option value='${option.code}'>${option.description}</option>`;
                        });

                        $('.sales-off').append(options);
                        $('.sales-off').val($('.defaultSalesOffice').val()).trigger('change');
                    }
                },

                error: function (er) {
                    console.log(er);
                }
            });
        }
    });
}(westcon));
